export const LogoMark = ({ className = "h-10 w-10" }) => (
    <img
        src="/azpm-logo.png"
        alt="AZPM — Azmatullah Packers and Movers logo"
        className={`${className} rounded-full object-cover`}
        width="512"
        height="512"
    />
);

export default function Logo({ light = false, compact = false }) {
    return (
        <span className="flex items-center gap-2.5" data-testid="nav-brand-logo">
            <LogoMark className="h-10 w-10 shrink-0" />
            {!compact && (
                <span className="flex flex-col leading-none">
                    <span
                        className={`font-display text-lg font-bold tracking-tight ${
                            light ? "text-white" : "text-ink"
                        }`}
                    >
                        Azmthullah
                    </span>
                    <span className="mt-0.5 text-[10px] font-semibold uppercase tracking-[0.22em] text-brand">
                        Packers &amp; Movers
                    </span>
                </span>
            )}
        </span>
    );
}
